export enum TaskStatus {
    NEW = 0,
    DONE = 1,
    NOT_DONE = 2
}

export class Task {
    public id: number;
    public name: string;
    public identifier: string;
    public description: string;
    public status: TaskStatus;
    public canStart: boolean;

    constructor(task: any = {}) {
        this.id = task.id || 0;
        this.name = task.name || '';
        this.identifier = task.identifier || '';
        this.description = task.description || '';
        this.status = task.status || TaskStatus.NEW;
        this.canStart = task.canStart || false;
    }

    get type() {
        return 'task';
    }
}
